export default __webpack_public_path__ + "static/media/44t.f431b263.jpg";